import script from "./student-certificates.vue?vue&type=script&setup=true&lang=js"
export * from "./student-certificates.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__